import { render, staticRenderFns } from "./CourseTeachingHours.vue?vue&type=template&id=63b2d793&"
import script from "./CourseTeachingHours.vue?vue&type=script&lang=ts&"
export * from "./CourseTeachingHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports